/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const createNumberValidation = (fieldName) =>
    Yup.number()
        .typeError(`Invalid data. '${fieldName}' must be a number`)
        .nullable(true)
        .test('is-number', `Invalid data. '${fieldName}' must be a number`, function (value) {
            return (value == null || value == undefined || !isNaN(value)) || this.createError({ message: `Invalid data. '${fieldName}' must be a number` });
        });

const TODIS_NIWW_SCHEMA = Yup.object().shape({
    //general section Rules:
    general_road_id: Yup.string("Road ID is alphanumeric").nullable(true),
    // startKm: Yup.number('Value should be number').integer("Number must be integer..").positive('Start KM should be positive..').nullable(true),
    // endKm: Yup.number('Value should be number').integer("Number must be integer..").positive('End KM should be positive..').nullable(true),
    dateValidTo: Yup.date("Valid from is a Date").nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").nullable(true),
    dateValidFor: Yup.string("Valid for is a Year").nullable(true),
    tenTCategory: Yup.string("tent category is alphanumeric").nullable(true),
    riverId: Yup.string("river ID is alphanumeric").nullable(true),
    internationalComm: Yup.string("internat Route ID is alphanumeric").nullable(true),
    startNodeName: Yup.string("Start Node Name is alphanumeric").nullable(true),
    endNodeName: Yup.string("End Node Name is alphanumeric").nullable(true),
    nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue == 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value == null || value == undefined;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),


    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue == 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null o undefined, lo consideramos válido y no aplicamos más validaciones
            if (value == null || value == undefined) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            // Verificar si es una cadena antes de intentar dividirla
            if (typeof value == 'string') {
                const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

                for (const email of emails) {
                    if (!emailRegex.test(email.trim())) {
                        throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                    }
                }
            }

            return true;
        }),
    countryCode: Yup.string("Country Code").nullable(true),
    startKmDirA: Yup.number("Start km Direction A").nullable(true),
    startKmDirB: Yup.number("Start km Direction B").nullable(true),
    endKmDirA: Yup.number("End km Direction A").nullable(true),
    endKmDirB: Yup.number("End km Direction B").nullable(true),
    remarks: Yup.string("remarks").nullable(true),

    iwwNpmEnvDTO: Yup.object().shape({
        airPollutGhgTpy: Yup.number('Value should be number').nullable(true),
        co2Ems: Yup.number('Value should be number').nullable(true),
        noxEms: Yup.number('Value should be number').nullable(true),
        so2Ems: Yup.number('Value should be number').nullable(true),
        nmhcEms: Yup.number('Value should be number').nullable(true),
        ppm: Yup.number('Value should be number').nullable(true),
        noise: Yup.number('Value should be number').nullable(true),
        chFloodInci: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        chClosureAdvWeatherCond: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        chEmbankFail: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        chWinterMaintDays: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),

    iwwNpmInfraDTO: Yup.object().shape({
        cemtClass: Yup.string('Value should be a text').nullable(true),
        width: createNumberValidation('Width'),
        condition: Yup.string('Value should be a text').nullable(true),
        singleLock: createNumberValidation('Single locks (no.)'),
        doubleLock: createNumberValidation('Double locks (no.)'),
        portsTransStorFaci: createNumberValidation('Ports, transhipment or storage facilities (no.)'),
        minDraught: createNumberValidation('Minimum draught (m)'),
        minBridgeHeight: createNumberValidation('Minimum bridge height (m)'),
        maxVesselLength: createNumberValidation('Maximum vessel length (m)'),
        maxVesselv: createNumberValidation('Maximum vessel width (m)'),
        upstreamOperSpeed: createNumberValidation('Operation speed – upstream (km/h)'),
        downstreamOperSpeed: createNumberValidation('Operation speed – downstream (km/h)'),
        its: Yup.boolean().nullable(true),
        itsType: Yup.string("itsType").nullable(true),
        riverInfoSys: Yup.boolean().nullable(true),
        publicationOnWebsite: Yup.boolean().nullable(true),
        lockMaintained: Yup.boolean().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    iwwNpmMaintDTO: Yup.object().shape({
        maintCostTotalPy: createNumberValidation('Maintenance cost – total (Euro/year)'),
        maintCostLandslidePy: createNumberValidation('Maintenance cost – landside infrastructure (Euro/year)'),
        maintCostRiverslidePy: createNumberValidation('Maintenance Cost – riverside infrastructure (Euro/year)'),
        financeSource: Yup.string("Source of Finance").nullable(true),
        reqHeavyMaint: createNumberValidation(''),
        reqRehab: createNumberValidation(''),
        reqUpgradeIncCap: createNumberValidation(''),
        remarks: Yup.string("remarks").nullable(true),
    }),
    iwwNpmOpsDTO: Yup.object().shape({
        upstreamVesselTraff: createNumberValidation('Traffic – upstream (total vessels/year)'),
        downstreamVeseelTraff: createNumberValidation('Traffic – downstream (total vessels/year)'),
        passTrafficPy: createNumberValidation('Passenger traffic (total no./year)'),
        freightTrafficTonsPy: createNumberValidation('Freight traffic (tonnes/year)'),
        dangerGoodsTonsTurnover: createNumberValidation('Dangerous Goods turnover (tonnes/year)'),
        teusPy: createNumberValidation('TEU containers (no./year)'),
        unitised: createNumberValidation('Unitised (% in standard loading units)'),
        nonUnitised: createNumberValidation('Non Unitised (% of bulk and general traffic)'),
        remarks: Yup.string("remarks").nullable(true),
    }),
    iwwNpmTentcompDTO: Yup.object().shape({
        category: Yup.boolean().nullable(true),
        draught: Yup.boolean().nullable(true),
        bridgeHeight: Yup.boolean().nullable(true),
        goodNavStatusMaint: Yup.boolean().nullable(true),
        risDeploy: Yup.boolean().nullable(true),
        publicationOnWebsite: Yup.string().nullable(true),
        lockMaintained: Yup.string().nullable(true),
        remarks: Yup.string("remarks").nullable(true),

    })

});
const NIWW_INIT = {
    //general section Rules:
    startKm: "",
    endKm: "",
    dateValidTo: "",
    dateValidFrom: "",
    dateValidFor: "",
    tenTCategory: "",
    riverId: "",
    internationalComm: "",
    startNodeName: "",
    endNodeName: "",
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    regionalPartner: "",
    startKmDirA: "",
    startKmDirB: "",
    endKmDirA: "",
    endKmDirB: "",
    remarks: "",
    iwwNpmEnvDTO: {
        airPollutGhgTpy: "",
        co2Ems: "",
        noxEms: "",
        so2Ems: "",
        nmhcEms: "",
        ppm: "",
        noise: "",
        chFloodInci: "",
        chClosureAdvWeatherCond: "",
        chEmbankFail: "",
        chWinterMaintDays: "",
        remarks: "",
    },
    iwwNpmInfraDTO: {
        cemtClass: "",
        width: "",
        condition: "",
        singleLock: "",
        doubleLock: "",
        portsTransStorFaci: "",
        minDraught: "",
        minBridgeHeight: "",
        maxVesselLength: "",
        maxVesselWidth: "",
        upstreamOperSpeed: "",
        downstreamOperSpeed: "",
        its: false,
        itsType: "",
        riverInfoSys: false,
        publicationOnWebsite: false,
        lockMaintained: false,
        remarks: "",
    },
    iwwNpmMaintDTO: {
        maintCostTotalPy: "",
        maintCostLandslidePy: "",
        maintCostRiverslidePy: "",
        financeSource: "",
        reqHeavyMaint: "",
        reqRehab: "",
        reqUpgradeIncCap: "",
        remarks: "",
    },
    iwwNpmOpsDTO: {
        upstreamVesselTraff: "",
        downstreamVeseelTraff: "",
        passTrafficPy: "",
        freightTrafficTonsPy: "",
        dangerGoodsTonsTurnover: "",
        teusPy: "",
        unitised: "",
        nonUnitised: "",
        remarks: "",
    },
    iwwNpmTentcompDTO: {
        category: false,
        draught: false,
        bridgeHeight: false,
        goodNavStatusMaint: false,
        risDeploy: false,
        publicationOnWebsite: "",
        lockMaintained: "",
        remarks: "",

    }
}

export { TODIS_NIWW_SCHEMA, NIWW_INIT };